/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as PasswordResetIndexRouteImport } from './routes/password-reset/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PasswordResetTokenRouteImport } from './routes/password-reset/$token'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminRoadmapRouteImport } from './routes/admin/roadmap'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings/index'
import { Route as AdminChangelogIndexRouteImport } from './routes/admin/changelog/index'
import { Route as PublicChangelogIndexRouteImport } from './routes/_public/changelog/index'
import { Route as PublicBoardSlugIndexRouteImport } from './routes/_public/$boardSlug/index'
import { Route as AdminUsersUserSlugRouteImport } from './routes/admin/users/$userSlug'
import { Route as AdminSettingsRoadmapRouteImport } from './routes/admin/settings/roadmap'
import { Route as AdminSettingsProfileRouteImport } from './routes/admin/settings/profile'
import { Route as AdminSettingsPreferencesRouteImport } from './routes/admin/settings/preferences'
import { Route as AdminSettingsCompanyRouteImport } from './routes/admin/settings/company'
import { Route as AdminSettingsChangelogRouteImport } from './routes/admin/settings/changelog'
import { Route as AdminSettingsBoardsRouteImport } from './routes/admin/settings/boards'
import { Route as AdminSettingsAdminsRouteImport } from './routes/admin/settings/admins'
import { Route as AdminRoadmapRoadmapSlugRouteImport } from './routes/admin/roadmap/$roadmapSlug'
import { Route as AdminFeedbackBoardSlugRouteImport } from './routes/admin/feedback/$boardSlug'
import { Route as AdminChangelogCreateRouteImport } from './routes/admin/changelog/create'
import { Route as PublicChangelogChangelogSlugRouteImport } from './routes/_public/changelog/$changelogSlug'
import { Route as AdminSettingsCustomDomainsIndexRouteImport } from './routes/admin/settings/custom-domains.index'
import { Route as PublicBoardSlugFeedbackSlugIndexRouteImport } from './routes/_public/$boardSlug/$feedbackSlug/index'
import { Route as AdminSettingsRoadmapStatusesRouteImport } from './routes/admin/settings/roadmap.statuses'
import { Route as AdminSettingsRoadmapPublicRouteImport } from './routes/admin/settings/roadmap.public'
import { Route as AdminSettingsRoadmapArchiveRouteImport } from './routes/admin/settings/roadmap.archive'
import { Route as AdminSettingsPreferencesLanguageRouteImport } from './routes/admin/settings/preferences.language'
import { Route as AdminSettingsPreferencesEmailRouteImport } from './routes/admin/settings/preferences.email'
import { Route as AdminSettingsCompanyPreferencesRouteImport } from './routes/admin/settings/company.preferences'
import { Route as AdminSettingsCompanyDeleteRouteImport } from './routes/admin/settings/company.delete'
import { Route as AdminSettingsCompanyBrandingRouteImport } from './routes/admin/settings/company.branding'
import { Route as AdminSettingsChangelogPrivacyRouteImport } from './routes/admin/settings/changelog.privacy'
import { Route as AdminSettingsChangelogLabelsRouteImport } from './routes/admin/settings/changelog.labels'
import { Route as AdminSettingsBoardsCreateNewRouteImport } from './routes/admin/settings/boards.create-new'
import { Route as AdminSettingsAdminsPeopleRouteImport } from './routes/admin/settings/admins.people'
import { Route as AdminRoadmapRoadmapSlugRenameRouteImport } from './routes/admin/roadmap/$roadmapSlug.rename'
import { Route as AdminRoadmapRoadmapSlugNewRouteImport } from './routes/admin/roadmap/$roadmapSlug.new'
import { Route as AdminRoadmapRoadmapSlugFilterRouteImport } from './routes/admin/roadmap/$roadmapSlug.filter'
import { Route as AdminRoadmapRoadmapSlugDeleteRouteImport } from './routes/admin/roadmap/$roadmapSlug.delete'
import { Route as AdminFeedbackBoardSlugFeedbackSlugRouteImport } from './routes/admin/feedback/$boardSlug/$feedbackSlug'
import { Route as AdminChangelogChangelogSlugEditRouteImport } from './routes/admin/changelog/$changelogSlug.edit'
import { Route as PublicBoardSlugFeedbackSlugVotersRouteImport } from './routes/_public/$boardSlug/$feedbackSlug/voters'
import { Route as PublicBoardSlugFeedbackSlugEditHistoryRouteImport } from './routes/_public/$boardSlug/$feedbackSlug/edit-history'
import { Route as PublicBoardSlugFeedbackSlugEditRouteImport } from './routes/_public/$boardSlug/$feedbackSlug/edit'
import { Route as AdminFeedbackBoardSlugFeedbackSlugIndexRouteImport } from './routes/admin/feedback/$boardSlug/$feedbackSlug/index'
import { Route as AdminSettingsBoardsBoardSlugTagsRouteImport } from './routes/admin/settings/boards.$boardSlug.tags'
import { Route as AdminSettingsBoardsBoardSlugPrivacyRouteImport } from './routes/admin/settings/boards.$boardSlug.privacy'
import { Route as AdminSettingsBoardsBoardSlugGeneralRouteImport } from './routes/admin/settings/boards.$boardSlug.general'
import { Route as AdminSettingsBoardsBoardSlugDeleteRouteImport } from './routes/admin/settings/boards.$boardSlug.delete'
import { Route as AdminSettingsBoardsBoardSlugCreateFormRouteImport } from './routes/admin/settings/boards.$boardSlug.create-form'
import { Route as AdminSettingsBoardsBoardSlugCategoriesRouteImport } from './routes/admin/settings/boards.$boardSlug.categories'
import { Route as AdminFeedbackBoardSlugFeedbackSlugVotersRouteImport } from './routes/admin/feedback/$boardSlug/$feedbackSlug/voters'
import { Route as AdminFeedbackBoardSlugFeedbackSlugEditHistoryRouteImport } from './routes/admin/feedback/$boardSlug/$feedbackSlug/edit-history'
import { Route as AdminFeedbackBoardSlugFeedbackSlugEditRouteImport } from './routes/admin/feedback/$boardSlug/$feedbackSlug/edit'
import { Route as AdminChangelogChangelogSlugEditPublishRouteImport } from './routes/admin/changelog/$changelogSlug.edit.publish'
import { Route as AdminChangelogChangelogSlugEditDeleteRouteImport } from './routes/admin/changelog/$changelogSlug.edit.delete'
import { Route as AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRouteImport } from './routes/admin/roadmap/$roadmapSlug.$boardSlug.$feedbackSlug.$feedbackId.remove'

const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetIndexRoute = PasswordResetIndexRouteImport.update({
  id: '/password-reset/',
  path: '/password-reset/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PasswordResetTokenRoute = PasswordResetTokenRouteImport.update({
  id: '/password-reset/$token',
  path: '/password-reset/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRoadmapRoute = AdminRoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminChangelogIndexRoute = AdminChangelogIndexRouteImport.update({
  id: '/changelog/',
  path: '/changelog/',
  getParentRoute: () => AdminRoute,
} as any)
const PublicChangelogIndexRoute = PublicChangelogIndexRouteImport.update({
  id: '/changelog/',
  path: '/changelog/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicBoardSlugIndexRoute = PublicBoardSlugIndexRouteImport.update({
  id: '/$boardSlug/',
  path: '/$boardSlug/',
  getParentRoute: () => PublicRoute,
} as any)
const AdminUsersUserSlugRoute = AdminUsersUserSlugRouteImport.update({
  id: '/$userSlug',
  path: '/$userSlug',
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminSettingsRoadmapRoute = AdminSettingsRoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsProfileRoute = AdminSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsPreferencesRoute =
  AdminSettingsPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsCompanyRoute = AdminSettingsCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsChangelogRoute = AdminSettingsChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsBoardsRoute = AdminSettingsBoardsRouteImport.update({
  id: '/boards',
  path: '/boards',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsAdminsRoute = AdminSettingsAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminRoadmapRoadmapSlugRoute = AdminRoadmapRoadmapSlugRouteImport.update({
  id: '/$roadmapSlug',
  path: '/$roadmapSlug',
  getParentRoute: () => AdminRoadmapRoute,
} as any)
const AdminFeedbackBoardSlugRoute = AdminFeedbackBoardSlugRouteImport.update({
  id: '/$boardSlug',
  path: '/$boardSlug',
  getParentRoute: () => AdminFeedbackRoute,
} as any)
const AdminChangelogCreateRoute = AdminChangelogCreateRouteImport.update({
  id: '/changelog/create',
  path: '/changelog/create',
  getParentRoute: () => AdminRoute,
} as any)
const PublicChangelogChangelogSlugRoute =
  PublicChangelogChangelogSlugRouteImport.update({
    id: '/changelog/$changelogSlug',
    path: '/changelog/$changelogSlug',
    getParentRoute: () => PublicRoute,
  } as any)
const AdminSettingsCustomDomainsIndexRoute =
  AdminSettingsCustomDomainsIndexRouteImport.update({
    id: '/custom-domains/',
    path: '/custom-domains/',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const PublicBoardSlugFeedbackSlugIndexRoute =
  PublicBoardSlugFeedbackSlugIndexRouteImport.update({
    id: '/$boardSlug/$feedbackSlug/',
    path: '/$boardSlug/$feedbackSlug/',
    getParentRoute: () => PublicRoute,
  } as any)
const AdminSettingsRoadmapStatusesRoute =
  AdminSettingsRoadmapStatusesRouteImport.update({
    id: '/statuses',
    path: '/statuses',
    getParentRoute: () => AdminSettingsRoadmapRoute,
  } as any)
const AdminSettingsRoadmapPublicRoute =
  AdminSettingsRoadmapPublicRouteImport.update({
    id: '/public',
    path: '/public',
    getParentRoute: () => AdminSettingsRoadmapRoute,
  } as any)
const AdminSettingsRoadmapArchiveRoute =
  AdminSettingsRoadmapArchiveRouteImport.update({
    id: '/archive',
    path: '/archive',
    getParentRoute: () => AdminSettingsRoadmapRoute,
  } as any)
const AdminSettingsPreferencesLanguageRoute =
  AdminSettingsPreferencesLanguageRouteImport.update({
    id: '/language',
    path: '/language',
    getParentRoute: () => AdminSettingsPreferencesRoute,
  } as any)
const AdminSettingsPreferencesEmailRoute =
  AdminSettingsPreferencesEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => AdminSettingsPreferencesRoute,
  } as any)
const AdminSettingsCompanyPreferencesRoute =
  AdminSettingsCompanyPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AdminSettingsCompanyRoute,
  } as any)
const AdminSettingsCompanyDeleteRoute =
  AdminSettingsCompanyDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AdminSettingsCompanyRoute,
  } as any)
const AdminSettingsCompanyBrandingRoute =
  AdminSettingsCompanyBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AdminSettingsCompanyRoute,
  } as any)
const AdminSettingsChangelogPrivacyRoute =
  AdminSettingsChangelogPrivacyRouteImport.update({
    id: '/privacy',
    path: '/privacy',
    getParentRoute: () => AdminSettingsChangelogRoute,
  } as any)
const AdminSettingsChangelogLabelsRoute =
  AdminSettingsChangelogLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => AdminSettingsChangelogRoute,
  } as any)
const AdminSettingsBoardsCreateNewRoute =
  AdminSettingsBoardsCreateNewRouteImport.update({
    id: '/create-new',
    path: '/create-new',
    getParentRoute: () => AdminSettingsBoardsRoute,
  } as any)
const AdminSettingsAdminsPeopleRoute =
  AdminSettingsAdminsPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => AdminSettingsAdminsRoute,
  } as any)
const AdminRoadmapRoadmapSlugRenameRoute =
  AdminRoadmapRoadmapSlugRenameRouteImport.update({
    id: '/rename',
    path: '/rename',
    getParentRoute: () => AdminRoadmapRoadmapSlugRoute,
  } as any)
const AdminRoadmapRoadmapSlugNewRoute =
  AdminRoadmapRoadmapSlugNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AdminRoadmapRoadmapSlugRoute,
  } as any)
const AdminRoadmapRoadmapSlugFilterRoute =
  AdminRoadmapRoadmapSlugFilterRouteImport.update({
    id: '/filter',
    path: '/filter',
    getParentRoute: () => AdminRoadmapRoadmapSlugRoute,
  } as any)
const AdminRoadmapRoadmapSlugDeleteRoute =
  AdminRoadmapRoadmapSlugDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AdminRoadmapRoadmapSlugRoute,
  } as any)
const AdminFeedbackBoardSlugFeedbackSlugRoute =
  AdminFeedbackBoardSlugFeedbackSlugRouteImport.update({
    id: '/$feedbackSlug',
    path: '/$feedbackSlug',
    getParentRoute: () => AdminFeedbackBoardSlugRoute,
  } as any)
const AdminChangelogChangelogSlugEditRoute =
  AdminChangelogChangelogSlugEditRouteImport.update({
    id: '/changelog/$changelogSlug/edit',
    path: '/changelog/$changelogSlug/edit',
    getParentRoute: () => AdminRoute,
  } as any)
const PublicBoardSlugFeedbackSlugVotersRoute =
  PublicBoardSlugFeedbackSlugVotersRouteImport.update({
    id: '/$boardSlug/$feedbackSlug/voters',
    path: '/$boardSlug/$feedbackSlug/voters',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicBoardSlugFeedbackSlugEditHistoryRoute =
  PublicBoardSlugFeedbackSlugEditHistoryRouteImport.update({
    id: '/$boardSlug/$feedbackSlug/edit-history',
    path: '/$boardSlug/$feedbackSlug/edit-history',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicBoardSlugFeedbackSlugEditRoute =
  PublicBoardSlugFeedbackSlugEditRouteImport.update({
    id: '/$boardSlug/$feedbackSlug/edit',
    path: '/$boardSlug/$feedbackSlug/edit',
    getParentRoute: () => PublicRoute,
  } as any)
const AdminFeedbackBoardSlugFeedbackSlugIndexRoute =
  AdminFeedbackBoardSlugFeedbackSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminFeedbackBoardSlugFeedbackSlugRoute,
  } as any)
const AdminSettingsBoardsBoardSlugTagsRoute =
  AdminSettingsBoardsBoardSlugTagsRouteImport.update({
    id: '/$boardSlug/tags',
    path: '/$boardSlug/tags',
    getParentRoute: () => AdminSettingsBoardsRoute,
  } as any)
const AdminSettingsBoardsBoardSlugPrivacyRoute =
  AdminSettingsBoardsBoardSlugPrivacyRouteImport.update({
    id: '/$boardSlug/privacy',
    path: '/$boardSlug/privacy',
    getParentRoute: () => AdminSettingsBoardsRoute,
  } as any)
const AdminSettingsBoardsBoardSlugGeneralRoute =
  AdminSettingsBoardsBoardSlugGeneralRouteImport.update({
    id: '/$boardSlug/general',
    path: '/$boardSlug/general',
    getParentRoute: () => AdminSettingsBoardsRoute,
  } as any)
const AdminSettingsBoardsBoardSlugDeleteRoute =
  AdminSettingsBoardsBoardSlugDeleteRouteImport.update({
    id: '/$boardSlug/delete',
    path: '/$boardSlug/delete',
    getParentRoute: () => AdminSettingsBoardsRoute,
  } as any)
const AdminSettingsBoardsBoardSlugCreateFormRoute =
  AdminSettingsBoardsBoardSlugCreateFormRouteImport.update({
    id: '/$boardSlug/create-form',
    path: '/$boardSlug/create-form',
    getParentRoute: () => AdminSettingsBoardsRoute,
  } as any)
const AdminSettingsBoardsBoardSlugCategoriesRoute =
  AdminSettingsBoardsBoardSlugCategoriesRouteImport.update({
    id: '/$boardSlug/categories',
    path: '/$boardSlug/categories',
    getParentRoute: () => AdminSettingsBoardsRoute,
  } as any)
const AdminFeedbackBoardSlugFeedbackSlugVotersRoute =
  AdminFeedbackBoardSlugFeedbackSlugVotersRouteImport.update({
    id: '/voters',
    path: '/voters',
    getParentRoute: () => AdminFeedbackBoardSlugFeedbackSlugRoute,
  } as any)
const AdminFeedbackBoardSlugFeedbackSlugEditHistoryRoute =
  AdminFeedbackBoardSlugFeedbackSlugEditHistoryRouteImport.update({
    id: '/edit-history',
    path: '/edit-history',
    getParentRoute: () => AdminFeedbackBoardSlugFeedbackSlugRoute,
  } as any)
const AdminFeedbackBoardSlugFeedbackSlugEditRoute =
  AdminFeedbackBoardSlugFeedbackSlugEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AdminFeedbackBoardSlugFeedbackSlugRoute,
  } as any)
const AdminChangelogChangelogSlugEditPublishRoute =
  AdminChangelogChangelogSlugEditPublishRouteImport.update({
    id: '/publish',
    path: '/publish',
    getParentRoute: () => AdminChangelogChangelogSlugEditRoute,
  } as any)
const AdminChangelogChangelogSlugEditDeleteRoute =
  AdminChangelogChangelogSlugEditDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AdminChangelogChangelogSlugEditRoute,
  } as any)
const AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRoute =
  AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRouteImport.update(
    {
      id: '/$boardSlug/$feedbackSlug/$feedbackId/remove',
      path: '/$boardSlug/$feedbackSlug/$feedbackId/remove',
      getParentRoute: () => AdminRoadmapRoadmapSlugRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRouteWithChildren
  '/admin/feedback': typeof AdminFeedbackRouteWithChildren
  '/admin/roadmap': typeof AdminRoadmapRouteWithChildren
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/password-reset/$token': typeof PasswordResetTokenRoute
  '/': typeof PublicIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/password-reset': typeof PasswordResetIndexRoute
  '/changelog/$changelogSlug': typeof PublicChangelogChangelogSlugRoute
  '/admin/changelog/create': typeof AdminChangelogCreateRoute
  '/admin/feedback/$boardSlug': typeof AdminFeedbackBoardSlugRouteWithChildren
  '/admin/roadmap/$roadmapSlug': typeof AdminRoadmapRoadmapSlugRouteWithChildren
  '/admin/settings/admins': typeof AdminSettingsAdminsRouteWithChildren
  '/admin/settings/boards': typeof AdminSettingsBoardsRouteWithChildren
  '/admin/settings/changelog': typeof AdminSettingsChangelogRouteWithChildren
  '/admin/settings/company': typeof AdminSettingsCompanyRouteWithChildren
  '/admin/settings/preferences': typeof AdminSettingsPreferencesRouteWithChildren
  '/admin/settings/profile': typeof AdminSettingsProfileRoute
  '/admin/settings/roadmap': typeof AdminSettingsRoadmapRouteWithChildren
  '/admin/users/$userSlug': typeof AdminUsersUserSlugRoute
  '/$boardSlug': typeof PublicBoardSlugIndexRoute
  '/changelog': typeof PublicChangelogIndexRoute
  '/admin/changelog': typeof AdminChangelogIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/$boardSlug/$feedbackSlug/edit': typeof PublicBoardSlugFeedbackSlugEditRoute
  '/$boardSlug/$feedbackSlug/edit-history': typeof PublicBoardSlugFeedbackSlugEditHistoryRoute
  '/$boardSlug/$feedbackSlug/voters': typeof PublicBoardSlugFeedbackSlugVotersRoute
  '/admin/changelog/$changelogSlug/edit': typeof AdminChangelogChangelogSlugEditRouteWithChildren
  '/admin/feedback/$boardSlug/$feedbackSlug': typeof AdminFeedbackBoardSlugFeedbackSlugRouteWithChildren
  '/admin/roadmap/$roadmapSlug/delete': typeof AdminRoadmapRoadmapSlugDeleteRoute
  '/admin/roadmap/$roadmapSlug/filter': typeof AdminRoadmapRoadmapSlugFilterRoute
  '/admin/roadmap/$roadmapSlug/new': typeof AdminRoadmapRoadmapSlugNewRoute
  '/admin/roadmap/$roadmapSlug/rename': typeof AdminRoadmapRoadmapSlugRenameRoute
  '/admin/settings/admins/people': typeof AdminSettingsAdminsPeopleRoute
  '/admin/settings/boards/create-new': typeof AdminSettingsBoardsCreateNewRoute
  '/admin/settings/changelog/labels': typeof AdminSettingsChangelogLabelsRoute
  '/admin/settings/changelog/privacy': typeof AdminSettingsChangelogPrivacyRoute
  '/admin/settings/company/branding': typeof AdminSettingsCompanyBrandingRoute
  '/admin/settings/company/delete': typeof AdminSettingsCompanyDeleteRoute
  '/admin/settings/company/preferences': typeof AdminSettingsCompanyPreferencesRoute
  '/admin/settings/preferences/email': typeof AdminSettingsPreferencesEmailRoute
  '/admin/settings/preferences/language': typeof AdminSettingsPreferencesLanguageRoute
  '/admin/settings/roadmap/archive': typeof AdminSettingsRoadmapArchiveRoute
  '/admin/settings/roadmap/public': typeof AdminSettingsRoadmapPublicRoute
  '/admin/settings/roadmap/statuses': typeof AdminSettingsRoadmapStatusesRoute
  '/$boardSlug/$feedbackSlug': typeof PublicBoardSlugFeedbackSlugIndexRoute
  '/admin/settings/custom-domains': typeof AdminSettingsCustomDomainsIndexRoute
  '/admin/changelog/$changelogSlug/edit/delete': typeof AdminChangelogChangelogSlugEditDeleteRoute
  '/admin/changelog/$changelogSlug/edit/publish': typeof AdminChangelogChangelogSlugEditPublishRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/edit': typeof AdminFeedbackBoardSlugFeedbackSlugEditRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/edit-history': typeof AdminFeedbackBoardSlugFeedbackSlugEditHistoryRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/voters': typeof AdminFeedbackBoardSlugFeedbackSlugVotersRoute
  '/admin/settings/boards/$boardSlug/categories': typeof AdminSettingsBoardsBoardSlugCategoriesRoute
  '/admin/settings/boards/$boardSlug/create-form': typeof AdminSettingsBoardsBoardSlugCreateFormRoute
  '/admin/settings/boards/$boardSlug/delete': typeof AdminSettingsBoardsBoardSlugDeleteRoute
  '/admin/settings/boards/$boardSlug/general': typeof AdminSettingsBoardsBoardSlugGeneralRoute
  '/admin/settings/boards/$boardSlug/privacy': typeof AdminSettingsBoardsBoardSlugPrivacyRoute
  '/admin/settings/boards/$boardSlug/tags': typeof AdminSettingsBoardsBoardSlugTagsRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/': typeof AdminFeedbackBoardSlugFeedbackSlugIndexRoute
  '/admin/roadmap/$roadmapSlug/$boardSlug/$feedbackSlug/$feedbackId/remove': typeof AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRoute
}
export interface FileRoutesByTo {
  '/admin/feedback': typeof AdminFeedbackRouteWithChildren
  '/admin/roadmap': typeof AdminRoadmapRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/password-reset/$token': typeof PasswordResetTokenRoute
  '/': typeof PublicIndexRoute
  '/admin': typeof AdminIndexRoute
  '/password-reset': typeof PasswordResetIndexRoute
  '/changelog/$changelogSlug': typeof PublicChangelogChangelogSlugRoute
  '/admin/changelog/create': typeof AdminChangelogCreateRoute
  '/admin/feedback/$boardSlug': typeof AdminFeedbackBoardSlugRouteWithChildren
  '/admin/roadmap/$roadmapSlug': typeof AdminRoadmapRoadmapSlugRouteWithChildren
  '/admin/settings/admins': typeof AdminSettingsAdminsRouteWithChildren
  '/admin/settings/boards': typeof AdminSettingsBoardsRouteWithChildren
  '/admin/settings/changelog': typeof AdminSettingsChangelogRouteWithChildren
  '/admin/settings/company': typeof AdminSettingsCompanyRouteWithChildren
  '/admin/settings/preferences': typeof AdminSettingsPreferencesRouteWithChildren
  '/admin/settings/profile': typeof AdminSettingsProfileRoute
  '/admin/settings/roadmap': typeof AdminSettingsRoadmapRouteWithChildren
  '/admin/users/$userSlug': typeof AdminUsersUserSlugRoute
  '/$boardSlug': typeof PublicBoardSlugIndexRoute
  '/changelog': typeof PublicChangelogIndexRoute
  '/admin/changelog': typeof AdminChangelogIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/$boardSlug/$feedbackSlug/edit': typeof PublicBoardSlugFeedbackSlugEditRoute
  '/$boardSlug/$feedbackSlug/edit-history': typeof PublicBoardSlugFeedbackSlugEditHistoryRoute
  '/$boardSlug/$feedbackSlug/voters': typeof PublicBoardSlugFeedbackSlugVotersRoute
  '/admin/changelog/$changelogSlug/edit': typeof AdminChangelogChangelogSlugEditRouteWithChildren
  '/admin/roadmap/$roadmapSlug/delete': typeof AdminRoadmapRoadmapSlugDeleteRoute
  '/admin/roadmap/$roadmapSlug/filter': typeof AdminRoadmapRoadmapSlugFilterRoute
  '/admin/roadmap/$roadmapSlug/new': typeof AdminRoadmapRoadmapSlugNewRoute
  '/admin/roadmap/$roadmapSlug/rename': typeof AdminRoadmapRoadmapSlugRenameRoute
  '/admin/settings/admins/people': typeof AdminSettingsAdminsPeopleRoute
  '/admin/settings/boards/create-new': typeof AdminSettingsBoardsCreateNewRoute
  '/admin/settings/changelog/labels': typeof AdminSettingsChangelogLabelsRoute
  '/admin/settings/changelog/privacy': typeof AdminSettingsChangelogPrivacyRoute
  '/admin/settings/company/branding': typeof AdminSettingsCompanyBrandingRoute
  '/admin/settings/company/delete': typeof AdminSettingsCompanyDeleteRoute
  '/admin/settings/company/preferences': typeof AdminSettingsCompanyPreferencesRoute
  '/admin/settings/preferences/email': typeof AdminSettingsPreferencesEmailRoute
  '/admin/settings/preferences/language': typeof AdminSettingsPreferencesLanguageRoute
  '/admin/settings/roadmap/archive': typeof AdminSettingsRoadmapArchiveRoute
  '/admin/settings/roadmap/public': typeof AdminSettingsRoadmapPublicRoute
  '/admin/settings/roadmap/statuses': typeof AdminSettingsRoadmapStatusesRoute
  '/$boardSlug/$feedbackSlug': typeof PublicBoardSlugFeedbackSlugIndexRoute
  '/admin/settings/custom-domains': typeof AdminSettingsCustomDomainsIndexRoute
  '/admin/changelog/$changelogSlug/edit/delete': typeof AdminChangelogChangelogSlugEditDeleteRoute
  '/admin/changelog/$changelogSlug/edit/publish': typeof AdminChangelogChangelogSlugEditPublishRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/edit': typeof AdminFeedbackBoardSlugFeedbackSlugEditRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/edit-history': typeof AdminFeedbackBoardSlugFeedbackSlugEditHistoryRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/voters': typeof AdminFeedbackBoardSlugFeedbackSlugVotersRoute
  '/admin/settings/boards/$boardSlug/categories': typeof AdminSettingsBoardsBoardSlugCategoriesRoute
  '/admin/settings/boards/$boardSlug/create-form': typeof AdminSettingsBoardsBoardSlugCreateFormRoute
  '/admin/settings/boards/$boardSlug/delete': typeof AdminSettingsBoardsBoardSlugDeleteRoute
  '/admin/settings/boards/$boardSlug/general': typeof AdminSettingsBoardsBoardSlugGeneralRoute
  '/admin/settings/boards/$boardSlug/privacy': typeof AdminSettingsBoardsBoardSlugPrivacyRoute
  '/admin/settings/boards/$boardSlug/tags': typeof AdminSettingsBoardsBoardSlugTagsRoute
  '/admin/feedback/$boardSlug/$feedbackSlug': typeof AdminFeedbackBoardSlugFeedbackSlugIndexRoute
  '/admin/roadmap/$roadmapSlug/$boardSlug/$feedbackSlug/$feedbackId/remove': typeof AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_public': typeof PublicRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/admin/feedback': typeof AdminFeedbackRouteWithChildren
  '/admin/roadmap': typeof AdminRoadmapRouteWithChildren
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/password-reset/$token': typeof PasswordResetTokenRoute
  '/_public/': typeof PublicIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/password-reset/': typeof PasswordResetIndexRoute
  '/_public/changelog/$changelogSlug': typeof PublicChangelogChangelogSlugRoute
  '/admin/changelog/create': typeof AdminChangelogCreateRoute
  '/admin/feedback/$boardSlug': typeof AdminFeedbackBoardSlugRouteWithChildren
  '/admin/roadmap/$roadmapSlug': typeof AdminRoadmapRoadmapSlugRouteWithChildren
  '/admin/settings/admins': typeof AdminSettingsAdminsRouteWithChildren
  '/admin/settings/boards': typeof AdminSettingsBoardsRouteWithChildren
  '/admin/settings/changelog': typeof AdminSettingsChangelogRouteWithChildren
  '/admin/settings/company': typeof AdminSettingsCompanyRouteWithChildren
  '/admin/settings/preferences': typeof AdminSettingsPreferencesRouteWithChildren
  '/admin/settings/profile': typeof AdminSettingsProfileRoute
  '/admin/settings/roadmap': typeof AdminSettingsRoadmapRouteWithChildren
  '/admin/users/$userSlug': typeof AdminUsersUserSlugRoute
  '/_public/$boardSlug/': typeof PublicBoardSlugIndexRoute
  '/_public/changelog/': typeof PublicChangelogIndexRoute
  '/admin/changelog/': typeof AdminChangelogIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/_public/$boardSlug/$feedbackSlug/edit': typeof PublicBoardSlugFeedbackSlugEditRoute
  '/_public/$boardSlug/$feedbackSlug/edit-history': typeof PublicBoardSlugFeedbackSlugEditHistoryRoute
  '/_public/$boardSlug/$feedbackSlug/voters': typeof PublicBoardSlugFeedbackSlugVotersRoute
  '/admin/changelog/$changelogSlug/edit': typeof AdminChangelogChangelogSlugEditRouteWithChildren
  '/admin/feedback/$boardSlug/$feedbackSlug': typeof AdminFeedbackBoardSlugFeedbackSlugRouteWithChildren
  '/admin/roadmap/$roadmapSlug/delete': typeof AdminRoadmapRoadmapSlugDeleteRoute
  '/admin/roadmap/$roadmapSlug/filter': typeof AdminRoadmapRoadmapSlugFilterRoute
  '/admin/roadmap/$roadmapSlug/new': typeof AdminRoadmapRoadmapSlugNewRoute
  '/admin/roadmap/$roadmapSlug/rename': typeof AdminRoadmapRoadmapSlugRenameRoute
  '/admin/settings/admins/people': typeof AdminSettingsAdminsPeopleRoute
  '/admin/settings/boards/create-new': typeof AdminSettingsBoardsCreateNewRoute
  '/admin/settings/changelog/labels': typeof AdminSettingsChangelogLabelsRoute
  '/admin/settings/changelog/privacy': typeof AdminSettingsChangelogPrivacyRoute
  '/admin/settings/company/branding': typeof AdminSettingsCompanyBrandingRoute
  '/admin/settings/company/delete': typeof AdminSettingsCompanyDeleteRoute
  '/admin/settings/company/preferences': typeof AdminSettingsCompanyPreferencesRoute
  '/admin/settings/preferences/email': typeof AdminSettingsPreferencesEmailRoute
  '/admin/settings/preferences/language': typeof AdminSettingsPreferencesLanguageRoute
  '/admin/settings/roadmap/archive': typeof AdminSettingsRoadmapArchiveRoute
  '/admin/settings/roadmap/public': typeof AdminSettingsRoadmapPublicRoute
  '/admin/settings/roadmap/statuses': typeof AdminSettingsRoadmapStatusesRoute
  '/_public/$boardSlug/$feedbackSlug/': typeof PublicBoardSlugFeedbackSlugIndexRoute
  '/admin/settings/custom-domains/': typeof AdminSettingsCustomDomainsIndexRoute
  '/admin/changelog/$changelogSlug/edit/delete': typeof AdminChangelogChangelogSlugEditDeleteRoute
  '/admin/changelog/$changelogSlug/edit/publish': typeof AdminChangelogChangelogSlugEditPublishRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/edit': typeof AdminFeedbackBoardSlugFeedbackSlugEditRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/edit-history': typeof AdminFeedbackBoardSlugFeedbackSlugEditHistoryRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/voters': typeof AdminFeedbackBoardSlugFeedbackSlugVotersRoute
  '/admin/settings/boards/$boardSlug/categories': typeof AdminSettingsBoardsBoardSlugCategoriesRoute
  '/admin/settings/boards/$boardSlug/create-form': typeof AdminSettingsBoardsBoardSlugCreateFormRoute
  '/admin/settings/boards/$boardSlug/delete': typeof AdminSettingsBoardsBoardSlugDeleteRoute
  '/admin/settings/boards/$boardSlug/general': typeof AdminSettingsBoardsBoardSlugGeneralRoute
  '/admin/settings/boards/$boardSlug/privacy': typeof AdminSettingsBoardsBoardSlugPrivacyRoute
  '/admin/settings/boards/$boardSlug/tags': typeof AdminSettingsBoardsBoardSlugTagsRoute
  '/admin/feedback/$boardSlug/$feedbackSlug/': typeof AdminFeedbackBoardSlugFeedbackSlugIndexRoute
  '/admin/roadmap/$roadmapSlug/$boardSlug/$feedbackSlug/$feedbackId/remove': typeof AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/admin/feedback'
    | '/admin/roadmap'
    | '/admin/settings'
    | '/admin/users'
    | '/password-reset/$token'
    | '/'
    | '/admin/'
    | '/password-reset'
    | '/changelog/$changelogSlug'
    | '/admin/changelog/create'
    | '/admin/feedback/$boardSlug'
    | '/admin/roadmap/$roadmapSlug'
    | '/admin/settings/admins'
    | '/admin/settings/boards'
    | '/admin/settings/changelog'
    | '/admin/settings/company'
    | '/admin/settings/preferences'
    | '/admin/settings/profile'
    | '/admin/settings/roadmap'
    | '/admin/users/$userSlug'
    | '/$boardSlug'
    | '/changelog'
    | '/admin/changelog'
    | '/admin/settings/'
    | '/$boardSlug/$feedbackSlug/edit'
    | '/$boardSlug/$feedbackSlug/edit-history'
    | '/$boardSlug/$feedbackSlug/voters'
    | '/admin/changelog/$changelogSlug/edit'
    | '/admin/feedback/$boardSlug/$feedbackSlug'
    | '/admin/roadmap/$roadmapSlug/delete'
    | '/admin/roadmap/$roadmapSlug/filter'
    | '/admin/roadmap/$roadmapSlug/new'
    | '/admin/roadmap/$roadmapSlug/rename'
    | '/admin/settings/admins/people'
    | '/admin/settings/boards/create-new'
    | '/admin/settings/changelog/labels'
    | '/admin/settings/changelog/privacy'
    | '/admin/settings/company/branding'
    | '/admin/settings/company/delete'
    | '/admin/settings/company/preferences'
    | '/admin/settings/preferences/email'
    | '/admin/settings/preferences/language'
    | '/admin/settings/roadmap/archive'
    | '/admin/settings/roadmap/public'
    | '/admin/settings/roadmap/statuses'
    | '/$boardSlug/$feedbackSlug'
    | '/admin/settings/custom-domains'
    | '/admin/changelog/$changelogSlug/edit/delete'
    | '/admin/changelog/$changelogSlug/edit/publish'
    | '/admin/feedback/$boardSlug/$feedbackSlug/edit'
    | '/admin/feedback/$boardSlug/$feedbackSlug/edit-history'
    | '/admin/feedback/$boardSlug/$feedbackSlug/voters'
    | '/admin/settings/boards/$boardSlug/categories'
    | '/admin/settings/boards/$boardSlug/create-form'
    | '/admin/settings/boards/$boardSlug/delete'
    | '/admin/settings/boards/$boardSlug/general'
    | '/admin/settings/boards/$boardSlug/privacy'
    | '/admin/settings/boards/$boardSlug/tags'
    | '/admin/feedback/$boardSlug/$feedbackSlug/'
    | '/admin/roadmap/$roadmapSlug/$boardSlug/$feedbackSlug/$feedbackId/remove'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/admin/feedback'
    | '/admin/roadmap'
    | '/admin/users'
    | '/password-reset/$token'
    | '/'
    | '/admin'
    | '/password-reset'
    | '/changelog/$changelogSlug'
    | '/admin/changelog/create'
    | '/admin/feedback/$boardSlug'
    | '/admin/roadmap/$roadmapSlug'
    | '/admin/settings/admins'
    | '/admin/settings/boards'
    | '/admin/settings/changelog'
    | '/admin/settings/company'
    | '/admin/settings/preferences'
    | '/admin/settings/profile'
    | '/admin/settings/roadmap'
    | '/admin/users/$userSlug'
    | '/$boardSlug'
    | '/changelog'
    | '/admin/changelog'
    | '/admin/settings'
    | '/$boardSlug/$feedbackSlug/edit'
    | '/$boardSlug/$feedbackSlug/edit-history'
    | '/$boardSlug/$feedbackSlug/voters'
    | '/admin/changelog/$changelogSlug/edit'
    | '/admin/roadmap/$roadmapSlug/delete'
    | '/admin/roadmap/$roadmapSlug/filter'
    | '/admin/roadmap/$roadmapSlug/new'
    | '/admin/roadmap/$roadmapSlug/rename'
    | '/admin/settings/admins/people'
    | '/admin/settings/boards/create-new'
    | '/admin/settings/changelog/labels'
    | '/admin/settings/changelog/privacy'
    | '/admin/settings/company/branding'
    | '/admin/settings/company/delete'
    | '/admin/settings/company/preferences'
    | '/admin/settings/preferences/email'
    | '/admin/settings/preferences/language'
    | '/admin/settings/roadmap/archive'
    | '/admin/settings/roadmap/public'
    | '/admin/settings/roadmap/statuses'
    | '/$boardSlug/$feedbackSlug'
    | '/admin/settings/custom-domains'
    | '/admin/changelog/$changelogSlug/edit/delete'
    | '/admin/changelog/$changelogSlug/edit/publish'
    | '/admin/feedback/$boardSlug/$feedbackSlug/edit'
    | '/admin/feedback/$boardSlug/$feedbackSlug/edit-history'
    | '/admin/feedback/$boardSlug/$feedbackSlug/voters'
    | '/admin/settings/boards/$boardSlug/categories'
    | '/admin/settings/boards/$boardSlug/create-form'
    | '/admin/settings/boards/$boardSlug/delete'
    | '/admin/settings/boards/$boardSlug/general'
    | '/admin/settings/boards/$boardSlug/privacy'
    | '/admin/settings/boards/$boardSlug/tags'
    | '/admin/feedback/$boardSlug/$feedbackSlug'
    | '/admin/roadmap/$roadmapSlug/$boardSlug/$feedbackSlug/$feedbackId/remove'
  id:
    | '__root__'
    | '/_public'
    | '/admin'
    | '/admin/feedback'
    | '/admin/roadmap'
    | '/admin/settings'
    | '/admin/users'
    | '/password-reset/$token'
    | '/_public/'
    | '/admin/'
    | '/password-reset/'
    | '/_public/changelog/$changelogSlug'
    | '/admin/changelog/create'
    | '/admin/feedback/$boardSlug'
    | '/admin/roadmap/$roadmapSlug'
    | '/admin/settings/admins'
    | '/admin/settings/boards'
    | '/admin/settings/changelog'
    | '/admin/settings/company'
    | '/admin/settings/preferences'
    | '/admin/settings/profile'
    | '/admin/settings/roadmap'
    | '/admin/users/$userSlug'
    | '/_public/$boardSlug/'
    | '/_public/changelog/'
    | '/admin/changelog/'
    | '/admin/settings/'
    | '/_public/$boardSlug/$feedbackSlug/edit'
    | '/_public/$boardSlug/$feedbackSlug/edit-history'
    | '/_public/$boardSlug/$feedbackSlug/voters'
    | '/admin/changelog/$changelogSlug/edit'
    | '/admin/feedback/$boardSlug/$feedbackSlug'
    | '/admin/roadmap/$roadmapSlug/delete'
    | '/admin/roadmap/$roadmapSlug/filter'
    | '/admin/roadmap/$roadmapSlug/new'
    | '/admin/roadmap/$roadmapSlug/rename'
    | '/admin/settings/admins/people'
    | '/admin/settings/boards/create-new'
    | '/admin/settings/changelog/labels'
    | '/admin/settings/changelog/privacy'
    | '/admin/settings/company/branding'
    | '/admin/settings/company/delete'
    | '/admin/settings/company/preferences'
    | '/admin/settings/preferences/email'
    | '/admin/settings/preferences/language'
    | '/admin/settings/roadmap/archive'
    | '/admin/settings/roadmap/public'
    | '/admin/settings/roadmap/statuses'
    | '/_public/$boardSlug/$feedbackSlug/'
    | '/admin/settings/custom-domains/'
    | '/admin/changelog/$changelogSlug/edit/delete'
    | '/admin/changelog/$changelogSlug/edit/publish'
    | '/admin/feedback/$boardSlug/$feedbackSlug/edit'
    | '/admin/feedback/$boardSlug/$feedbackSlug/edit-history'
    | '/admin/feedback/$boardSlug/$feedbackSlug/voters'
    | '/admin/settings/boards/$boardSlug/categories'
    | '/admin/settings/boards/$boardSlug/create-form'
    | '/admin/settings/boards/$boardSlug/delete'
    | '/admin/settings/boards/$boardSlug/general'
    | '/admin/settings/boards/$boardSlug/privacy'
    | '/admin/settings/boards/$boardSlug/tags'
    | '/admin/feedback/$boardSlug/$feedbackSlug/'
    | '/admin/roadmap/$roadmapSlug/$boardSlug/$feedbackSlug/$feedbackId/remove'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PublicRoute: typeof PublicRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  PasswordResetTokenRoute: typeof PasswordResetTokenRoute
  PasswordResetIndexRoute: typeof PasswordResetIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset/': {
      id: '/password-reset/'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/password-reset/$token': {
      id: '/password-reset/$token'
      path: '/password-reset/$token'
      fullPath: '/password-reset/$token'
      preLoaderRoute: typeof PasswordResetTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/roadmap': {
      id: '/admin/roadmap'
      path: '/roadmap'
      fullPath: '/admin/roadmap'
      preLoaderRoute: typeof AdminRoadmapRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feedback': {
      id: '/admin/feedback'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/changelog/': {
      id: '/admin/changelog/'
      path: '/changelog'
      fullPath: '/admin/changelog'
      preLoaderRoute: typeof AdminChangelogIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_public/changelog/': {
      id: '/_public/changelog/'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof PublicChangelogIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/$boardSlug/': {
      id: '/_public/$boardSlug/'
      path: '/$boardSlug'
      fullPath: '/$boardSlug'
      preLoaderRoute: typeof PublicBoardSlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/users/$userSlug': {
      id: '/admin/users/$userSlug'
      path: '/$userSlug'
      fullPath: '/admin/users/$userSlug'
      preLoaderRoute: typeof AdminUsersUserSlugRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/admin/settings/roadmap': {
      id: '/admin/settings/roadmap'
      path: '/roadmap'
      fullPath: '/admin/settings/roadmap'
      preLoaderRoute: typeof AdminSettingsRoadmapRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/profile': {
      id: '/admin/settings/profile'
      path: '/profile'
      fullPath: '/admin/settings/profile'
      preLoaderRoute: typeof AdminSettingsProfileRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/preferences': {
      id: '/admin/settings/preferences'
      path: '/preferences'
      fullPath: '/admin/settings/preferences'
      preLoaderRoute: typeof AdminSettingsPreferencesRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/company': {
      id: '/admin/settings/company'
      path: '/company'
      fullPath: '/admin/settings/company'
      preLoaderRoute: typeof AdminSettingsCompanyRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/changelog': {
      id: '/admin/settings/changelog'
      path: '/changelog'
      fullPath: '/admin/settings/changelog'
      preLoaderRoute: typeof AdminSettingsChangelogRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/boards': {
      id: '/admin/settings/boards'
      path: '/boards'
      fullPath: '/admin/settings/boards'
      preLoaderRoute: typeof AdminSettingsBoardsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/admins': {
      id: '/admin/settings/admins'
      path: '/admins'
      fullPath: '/admin/settings/admins'
      preLoaderRoute: typeof AdminSettingsAdminsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/roadmap/$roadmapSlug': {
      id: '/admin/roadmap/$roadmapSlug'
      path: '/$roadmapSlug'
      fullPath: '/admin/roadmap/$roadmapSlug'
      preLoaderRoute: typeof AdminRoadmapRoadmapSlugRouteImport
      parentRoute: typeof AdminRoadmapRoute
    }
    '/admin/feedback/$boardSlug': {
      id: '/admin/feedback/$boardSlug'
      path: '/$boardSlug'
      fullPath: '/admin/feedback/$boardSlug'
      preLoaderRoute: typeof AdminFeedbackBoardSlugRouteImport
      parentRoute: typeof AdminFeedbackRoute
    }
    '/admin/changelog/create': {
      id: '/admin/changelog/create'
      path: '/changelog/create'
      fullPath: '/admin/changelog/create'
      preLoaderRoute: typeof AdminChangelogCreateRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_public/changelog/$changelogSlug': {
      id: '/_public/changelog/$changelogSlug'
      path: '/changelog/$changelogSlug'
      fullPath: '/changelog/$changelogSlug'
      preLoaderRoute: typeof PublicChangelogChangelogSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/settings/custom-domains/': {
      id: '/admin/settings/custom-domains/'
      path: '/custom-domains'
      fullPath: '/admin/settings/custom-domains'
      preLoaderRoute: typeof AdminSettingsCustomDomainsIndexRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_public/$boardSlug/$feedbackSlug/': {
      id: '/_public/$boardSlug/$feedbackSlug/'
      path: '/$boardSlug/$feedbackSlug'
      fullPath: '/$boardSlug/$feedbackSlug'
      preLoaderRoute: typeof PublicBoardSlugFeedbackSlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/settings/roadmap/statuses': {
      id: '/admin/settings/roadmap/statuses'
      path: '/statuses'
      fullPath: '/admin/settings/roadmap/statuses'
      preLoaderRoute: typeof AdminSettingsRoadmapStatusesRouteImport
      parentRoute: typeof AdminSettingsRoadmapRoute
    }
    '/admin/settings/roadmap/public': {
      id: '/admin/settings/roadmap/public'
      path: '/public'
      fullPath: '/admin/settings/roadmap/public'
      preLoaderRoute: typeof AdminSettingsRoadmapPublicRouteImport
      parentRoute: typeof AdminSettingsRoadmapRoute
    }
    '/admin/settings/roadmap/archive': {
      id: '/admin/settings/roadmap/archive'
      path: '/archive'
      fullPath: '/admin/settings/roadmap/archive'
      preLoaderRoute: typeof AdminSettingsRoadmapArchiveRouteImport
      parentRoute: typeof AdminSettingsRoadmapRoute
    }
    '/admin/settings/preferences/language': {
      id: '/admin/settings/preferences/language'
      path: '/language'
      fullPath: '/admin/settings/preferences/language'
      preLoaderRoute: typeof AdminSettingsPreferencesLanguageRouteImport
      parentRoute: typeof AdminSettingsPreferencesRoute
    }
    '/admin/settings/preferences/email': {
      id: '/admin/settings/preferences/email'
      path: '/email'
      fullPath: '/admin/settings/preferences/email'
      preLoaderRoute: typeof AdminSettingsPreferencesEmailRouteImport
      parentRoute: typeof AdminSettingsPreferencesRoute
    }
    '/admin/settings/company/preferences': {
      id: '/admin/settings/company/preferences'
      path: '/preferences'
      fullPath: '/admin/settings/company/preferences'
      preLoaderRoute: typeof AdminSettingsCompanyPreferencesRouteImport
      parentRoute: typeof AdminSettingsCompanyRoute
    }
    '/admin/settings/company/delete': {
      id: '/admin/settings/company/delete'
      path: '/delete'
      fullPath: '/admin/settings/company/delete'
      preLoaderRoute: typeof AdminSettingsCompanyDeleteRouteImport
      parentRoute: typeof AdminSettingsCompanyRoute
    }
    '/admin/settings/company/branding': {
      id: '/admin/settings/company/branding'
      path: '/branding'
      fullPath: '/admin/settings/company/branding'
      preLoaderRoute: typeof AdminSettingsCompanyBrandingRouteImport
      parentRoute: typeof AdminSettingsCompanyRoute
    }
    '/admin/settings/changelog/privacy': {
      id: '/admin/settings/changelog/privacy'
      path: '/privacy'
      fullPath: '/admin/settings/changelog/privacy'
      preLoaderRoute: typeof AdminSettingsChangelogPrivacyRouteImport
      parentRoute: typeof AdminSettingsChangelogRoute
    }
    '/admin/settings/changelog/labels': {
      id: '/admin/settings/changelog/labels'
      path: '/labels'
      fullPath: '/admin/settings/changelog/labels'
      preLoaderRoute: typeof AdminSettingsChangelogLabelsRouteImport
      parentRoute: typeof AdminSettingsChangelogRoute
    }
    '/admin/settings/boards/create-new': {
      id: '/admin/settings/boards/create-new'
      path: '/create-new'
      fullPath: '/admin/settings/boards/create-new'
      preLoaderRoute: typeof AdminSettingsBoardsCreateNewRouteImport
      parentRoute: typeof AdminSettingsBoardsRoute
    }
    '/admin/settings/admins/people': {
      id: '/admin/settings/admins/people'
      path: '/people'
      fullPath: '/admin/settings/admins/people'
      preLoaderRoute: typeof AdminSettingsAdminsPeopleRouteImport
      parentRoute: typeof AdminSettingsAdminsRoute
    }
    '/admin/roadmap/$roadmapSlug/rename': {
      id: '/admin/roadmap/$roadmapSlug/rename'
      path: '/rename'
      fullPath: '/admin/roadmap/$roadmapSlug/rename'
      preLoaderRoute: typeof AdminRoadmapRoadmapSlugRenameRouteImport
      parentRoute: typeof AdminRoadmapRoadmapSlugRoute
    }
    '/admin/roadmap/$roadmapSlug/new': {
      id: '/admin/roadmap/$roadmapSlug/new'
      path: '/new'
      fullPath: '/admin/roadmap/$roadmapSlug/new'
      preLoaderRoute: typeof AdminRoadmapRoadmapSlugNewRouteImport
      parentRoute: typeof AdminRoadmapRoadmapSlugRoute
    }
    '/admin/roadmap/$roadmapSlug/filter': {
      id: '/admin/roadmap/$roadmapSlug/filter'
      path: '/filter'
      fullPath: '/admin/roadmap/$roadmapSlug/filter'
      preLoaderRoute: typeof AdminRoadmapRoadmapSlugFilterRouteImport
      parentRoute: typeof AdminRoadmapRoadmapSlugRoute
    }
    '/admin/roadmap/$roadmapSlug/delete': {
      id: '/admin/roadmap/$roadmapSlug/delete'
      path: '/delete'
      fullPath: '/admin/roadmap/$roadmapSlug/delete'
      preLoaderRoute: typeof AdminRoadmapRoadmapSlugDeleteRouteImport
      parentRoute: typeof AdminRoadmapRoadmapSlugRoute
    }
    '/admin/feedback/$boardSlug/$feedbackSlug': {
      id: '/admin/feedback/$boardSlug/$feedbackSlug'
      path: '/$feedbackSlug'
      fullPath: '/admin/feedback/$boardSlug/$feedbackSlug'
      preLoaderRoute: typeof AdminFeedbackBoardSlugFeedbackSlugRouteImport
      parentRoute: typeof AdminFeedbackBoardSlugRoute
    }
    '/admin/changelog/$changelogSlug/edit': {
      id: '/admin/changelog/$changelogSlug/edit'
      path: '/changelog/$changelogSlug/edit'
      fullPath: '/admin/changelog/$changelogSlug/edit'
      preLoaderRoute: typeof AdminChangelogChangelogSlugEditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_public/$boardSlug/$feedbackSlug/voters': {
      id: '/_public/$boardSlug/$feedbackSlug/voters'
      path: '/$boardSlug/$feedbackSlug/voters'
      fullPath: '/$boardSlug/$feedbackSlug/voters'
      preLoaderRoute: typeof PublicBoardSlugFeedbackSlugVotersRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/$boardSlug/$feedbackSlug/edit-history': {
      id: '/_public/$boardSlug/$feedbackSlug/edit-history'
      path: '/$boardSlug/$feedbackSlug/edit-history'
      fullPath: '/$boardSlug/$feedbackSlug/edit-history'
      preLoaderRoute: typeof PublicBoardSlugFeedbackSlugEditHistoryRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/$boardSlug/$feedbackSlug/edit': {
      id: '/_public/$boardSlug/$feedbackSlug/edit'
      path: '/$boardSlug/$feedbackSlug/edit'
      fullPath: '/$boardSlug/$feedbackSlug/edit'
      preLoaderRoute: typeof PublicBoardSlugFeedbackSlugEditRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/feedback/$boardSlug/$feedbackSlug/': {
      id: '/admin/feedback/$boardSlug/$feedbackSlug/'
      path: '/'
      fullPath: '/admin/feedback/$boardSlug/$feedbackSlug/'
      preLoaderRoute: typeof AdminFeedbackBoardSlugFeedbackSlugIndexRouteImport
      parentRoute: typeof AdminFeedbackBoardSlugFeedbackSlugRoute
    }
    '/admin/settings/boards/$boardSlug/tags': {
      id: '/admin/settings/boards/$boardSlug/tags'
      path: '/$boardSlug/tags'
      fullPath: '/admin/settings/boards/$boardSlug/tags'
      preLoaderRoute: typeof AdminSettingsBoardsBoardSlugTagsRouteImport
      parentRoute: typeof AdminSettingsBoardsRoute
    }
    '/admin/settings/boards/$boardSlug/privacy': {
      id: '/admin/settings/boards/$boardSlug/privacy'
      path: '/$boardSlug/privacy'
      fullPath: '/admin/settings/boards/$boardSlug/privacy'
      preLoaderRoute: typeof AdminSettingsBoardsBoardSlugPrivacyRouteImport
      parentRoute: typeof AdminSettingsBoardsRoute
    }
    '/admin/settings/boards/$boardSlug/general': {
      id: '/admin/settings/boards/$boardSlug/general'
      path: '/$boardSlug/general'
      fullPath: '/admin/settings/boards/$boardSlug/general'
      preLoaderRoute: typeof AdminSettingsBoardsBoardSlugGeneralRouteImport
      parentRoute: typeof AdminSettingsBoardsRoute
    }
    '/admin/settings/boards/$boardSlug/delete': {
      id: '/admin/settings/boards/$boardSlug/delete'
      path: '/$boardSlug/delete'
      fullPath: '/admin/settings/boards/$boardSlug/delete'
      preLoaderRoute: typeof AdminSettingsBoardsBoardSlugDeleteRouteImport
      parentRoute: typeof AdminSettingsBoardsRoute
    }
    '/admin/settings/boards/$boardSlug/create-form': {
      id: '/admin/settings/boards/$boardSlug/create-form'
      path: '/$boardSlug/create-form'
      fullPath: '/admin/settings/boards/$boardSlug/create-form'
      preLoaderRoute: typeof AdminSettingsBoardsBoardSlugCreateFormRouteImport
      parentRoute: typeof AdminSettingsBoardsRoute
    }
    '/admin/settings/boards/$boardSlug/categories': {
      id: '/admin/settings/boards/$boardSlug/categories'
      path: '/$boardSlug/categories'
      fullPath: '/admin/settings/boards/$boardSlug/categories'
      preLoaderRoute: typeof AdminSettingsBoardsBoardSlugCategoriesRouteImport
      parentRoute: typeof AdminSettingsBoardsRoute
    }
    '/admin/feedback/$boardSlug/$feedbackSlug/voters': {
      id: '/admin/feedback/$boardSlug/$feedbackSlug/voters'
      path: '/voters'
      fullPath: '/admin/feedback/$boardSlug/$feedbackSlug/voters'
      preLoaderRoute: typeof AdminFeedbackBoardSlugFeedbackSlugVotersRouteImport
      parentRoute: typeof AdminFeedbackBoardSlugFeedbackSlugRoute
    }
    '/admin/feedback/$boardSlug/$feedbackSlug/edit-history': {
      id: '/admin/feedback/$boardSlug/$feedbackSlug/edit-history'
      path: '/edit-history'
      fullPath: '/admin/feedback/$boardSlug/$feedbackSlug/edit-history'
      preLoaderRoute: typeof AdminFeedbackBoardSlugFeedbackSlugEditHistoryRouteImport
      parentRoute: typeof AdminFeedbackBoardSlugFeedbackSlugRoute
    }
    '/admin/feedback/$boardSlug/$feedbackSlug/edit': {
      id: '/admin/feedback/$boardSlug/$feedbackSlug/edit'
      path: '/edit'
      fullPath: '/admin/feedback/$boardSlug/$feedbackSlug/edit'
      preLoaderRoute: typeof AdminFeedbackBoardSlugFeedbackSlugEditRouteImport
      parentRoute: typeof AdminFeedbackBoardSlugFeedbackSlugRoute
    }
    '/admin/changelog/$changelogSlug/edit/publish': {
      id: '/admin/changelog/$changelogSlug/edit/publish'
      path: '/publish'
      fullPath: '/admin/changelog/$changelogSlug/edit/publish'
      preLoaderRoute: typeof AdminChangelogChangelogSlugEditPublishRouteImport
      parentRoute: typeof AdminChangelogChangelogSlugEditRoute
    }
    '/admin/changelog/$changelogSlug/edit/delete': {
      id: '/admin/changelog/$changelogSlug/edit/delete'
      path: '/delete'
      fullPath: '/admin/changelog/$changelogSlug/edit/delete'
      preLoaderRoute: typeof AdminChangelogChangelogSlugEditDeleteRouteImport
      parentRoute: typeof AdminChangelogChangelogSlugEditRoute
    }
    '/admin/roadmap/$roadmapSlug/$boardSlug/$feedbackSlug/$feedbackId/remove': {
      id: '/admin/roadmap/$roadmapSlug/$boardSlug/$feedbackSlug/$feedbackId/remove'
      path: '/$boardSlug/$feedbackSlug/$feedbackId/remove'
      fullPath: '/admin/roadmap/$roadmapSlug/$boardSlug/$feedbackSlug/$feedbackId/remove'
      preLoaderRoute: typeof AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRouteImport
      parentRoute: typeof AdminRoadmapRoadmapSlugRoute
    }
  }
}

interface PublicRouteChildren {
  PublicIndexRoute: typeof PublicIndexRoute
  PublicChangelogChangelogSlugRoute: typeof PublicChangelogChangelogSlugRoute
  PublicBoardSlugIndexRoute: typeof PublicBoardSlugIndexRoute
  PublicChangelogIndexRoute: typeof PublicChangelogIndexRoute
  PublicBoardSlugFeedbackSlugEditRoute: typeof PublicBoardSlugFeedbackSlugEditRoute
  PublicBoardSlugFeedbackSlugEditHistoryRoute: typeof PublicBoardSlugFeedbackSlugEditHistoryRoute
  PublicBoardSlugFeedbackSlugVotersRoute: typeof PublicBoardSlugFeedbackSlugVotersRoute
  PublicBoardSlugFeedbackSlugIndexRoute: typeof PublicBoardSlugFeedbackSlugIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicIndexRoute: PublicIndexRoute,
  PublicChangelogChangelogSlugRoute: PublicChangelogChangelogSlugRoute,
  PublicBoardSlugIndexRoute: PublicBoardSlugIndexRoute,
  PublicChangelogIndexRoute: PublicChangelogIndexRoute,
  PublicBoardSlugFeedbackSlugEditRoute: PublicBoardSlugFeedbackSlugEditRoute,
  PublicBoardSlugFeedbackSlugEditHistoryRoute:
    PublicBoardSlugFeedbackSlugEditHistoryRoute,
  PublicBoardSlugFeedbackSlugVotersRoute:
    PublicBoardSlugFeedbackSlugVotersRoute,
  PublicBoardSlugFeedbackSlugIndexRoute: PublicBoardSlugFeedbackSlugIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface AdminFeedbackBoardSlugFeedbackSlugRouteChildren {
  AdminFeedbackBoardSlugFeedbackSlugEditRoute: typeof AdminFeedbackBoardSlugFeedbackSlugEditRoute
  AdminFeedbackBoardSlugFeedbackSlugEditHistoryRoute: typeof AdminFeedbackBoardSlugFeedbackSlugEditHistoryRoute
  AdminFeedbackBoardSlugFeedbackSlugVotersRoute: typeof AdminFeedbackBoardSlugFeedbackSlugVotersRoute
  AdminFeedbackBoardSlugFeedbackSlugIndexRoute: typeof AdminFeedbackBoardSlugFeedbackSlugIndexRoute
}

const AdminFeedbackBoardSlugFeedbackSlugRouteChildren: AdminFeedbackBoardSlugFeedbackSlugRouteChildren =
  {
    AdminFeedbackBoardSlugFeedbackSlugEditRoute:
      AdminFeedbackBoardSlugFeedbackSlugEditRoute,
    AdminFeedbackBoardSlugFeedbackSlugEditHistoryRoute:
      AdminFeedbackBoardSlugFeedbackSlugEditHistoryRoute,
    AdminFeedbackBoardSlugFeedbackSlugVotersRoute:
      AdminFeedbackBoardSlugFeedbackSlugVotersRoute,
    AdminFeedbackBoardSlugFeedbackSlugIndexRoute:
      AdminFeedbackBoardSlugFeedbackSlugIndexRoute,
  }

const AdminFeedbackBoardSlugFeedbackSlugRouteWithChildren =
  AdminFeedbackBoardSlugFeedbackSlugRoute._addFileChildren(
    AdminFeedbackBoardSlugFeedbackSlugRouteChildren,
  )

interface AdminFeedbackBoardSlugRouteChildren {
  AdminFeedbackBoardSlugFeedbackSlugRoute: typeof AdminFeedbackBoardSlugFeedbackSlugRouteWithChildren
}

const AdminFeedbackBoardSlugRouteChildren: AdminFeedbackBoardSlugRouteChildren =
  {
    AdminFeedbackBoardSlugFeedbackSlugRoute:
      AdminFeedbackBoardSlugFeedbackSlugRouteWithChildren,
  }

const AdminFeedbackBoardSlugRouteWithChildren =
  AdminFeedbackBoardSlugRoute._addFileChildren(
    AdminFeedbackBoardSlugRouteChildren,
  )

interface AdminFeedbackRouteChildren {
  AdminFeedbackBoardSlugRoute: typeof AdminFeedbackBoardSlugRouteWithChildren
}

const AdminFeedbackRouteChildren: AdminFeedbackRouteChildren = {
  AdminFeedbackBoardSlugRoute: AdminFeedbackBoardSlugRouteWithChildren,
}

const AdminFeedbackRouteWithChildren = AdminFeedbackRoute._addFileChildren(
  AdminFeedbackRouteChildren,
)

interface AdminRoadmapRoadmapSlugRouteChildren {
  AdminRoadmapRoadmapSlugDeleteRoute: typeof AdminRoadmapRoadmapSlugDeleteRoute
  AdminRoadmapRoadmapSlugFilterRoute: typeof AdminRoadmapRoadmapSlugFilterRoute
  AdminRoadmapRoadmapSlugNewRoute: typeof AdminRoadmapRoadmapSlugNewRoute
  AdminRoadmapRoadmapSlugRenameRoute: typeof AdminRoadmapRoadmapSlugRenameRoute
  AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRoute: typeof AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRoute
}

const AdminRoadmapRoadmapSlugRouteChildren: AdminRoadmapRoadmapSlugRouteChildren =
  {
    AdminRoadmapRoadmapSlugDeleteRoute: AdminRoadmapRoadmapSlugDeleteRoute,
    AdminRoadmapRoadmapSlugFilterRoute: AdminRoadmapRoadmapSlugFilterRoute,
    AdminRoadmapRoadmapSlugNewRoute: AdminRoadmapRoadmapSlugNewRoute,
    AdminRoadmapRoadmapSlugRenameRoute: AdminRoadmapRoadmapSlugRenameRoute,
    AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRoute:
      AdminRoadmapRoadmapSlugBoardSlugFeedbackSlugFeedbackIdRemoveRoute,
  }

const AdminRoadmapRoadmapSlugRouteWithChildren =
  AdminRoadmapRoadmapSlugRoute._addFileChildren(
    AdminRoadmapRoadmapSlugRouteChildren,
  )

interface AdminRoadmapRouteChildren {
  AdminRoadmapRoadmapSlugRoute: typeof AdminRoadmapRoadmapSlugRouteWithChildren
}

const AdminRoadmapRouteChildren: AdminRoadmapRouteChildren = {
  AdminRoadmapRoadmapSlugRoute: AdminRoadmapRoadmapSlugRouteWithChildren,
}

const AdminRoadmapRouteWithChildren = AdminRoadmapRoute._addFileChildren(
  AdminRoadmapRouteChildren,
)

interface AdminSettingsAdminsRouteChildren {
  AdminSettingsAdminsPeopleRoute: typeof AdminSettingsAdminsPeopleRoute
}

const AdminSettingsAdminsRouteChildren: AdminSettingsAdminsRouteChildren = {
  AdminSettingsAdminsPeopleRoute: AdminSettingsAdminsPeopleRoute,
}

const AdminSettingsAdminsRouteWithChildren =
  AdminSettingsAdminsRoute._addFileChildren(AdminSettingsAdminsRouteChildren)

interface AdminSettingsBoardsRouteChildren {
  AdminSettingsBoardsCreateNewRoute: typeof AdminSettingsBoardsCreateNewRoute
  AdminSettingsBoardsBoardSlugCategoriesRoute: typeof AdminSettingsBoardsBoardSlugCategoriesRoute
  AdminSettingsBoardsBoardSlugCreateFormRoute: typeof AdminSettingsBoardsBoardSlugCreateFormRoute
  AdminSettingsBoardsBoardSlugDeleteRoute: typeof AdminSettingsBoardsBoardSlugDeleteRoute
  AdminSettingsBoardsBoardSlugGeneralRoute: typeof AdminSettingsBoardsBoardSlugGeneralRoute
  AdminSettingsBoardsBoardSlugPrivacyRoute: typeof AdminSettingsBoardsBoardSlugPrivacyRoute
  AdminSettingsBoardsBoardSlugTagsRoute: typeof AdminSettingsBoardsBoardSlugTagsRoute
}

const AdminSettingsBoardsRouteChildren: AdminSettingsBoardsRouteChildren = {
  AdminSettingsBoardsCreateNewRoute: AdminSettingsBoardsCreateNewRoute,
  AdminSettingsBoardsBoardSlugCategoriesRoute:
    AdminSettingsBoardsBoardSlugCategoriesRoute,
  AdminSettingsBoardsBoardSlugCreateFormRoute:
    AdminSettingsBoardsBoardSlugCreateFormRoute,
  AdminSettingsBoardsBoardSlugDeleteRoute:
    AdminSettingsBoardsBoardSlugDeleteRoute,
  AdminSettingsBoardsBoardSlugGeneralRoute:
    AdminSettingsBoardsBoardSlugGeneralRoute,
  AdminSettingsBoardsBoardSlugPrivacyRoute:
    AdminSettingsBoardsBoardSlugPrivacyRoute,
  AdminSettingsBoardsBoardSlugTagsRoute: AdminSettingsBoardsBoardSlugTagsRoute,
}

const AdminSettingsBoardsRouteWithChildren =
  AdminSettingsBoardsRoute._addFileChildren(AdminSettingsBoardsRouteChildren)

interface AdminSettingsChangelogRouteChildren {
  AdminSettingsChangelogLabelsRoute: typeof AdminSettingsChangelogLabelsRoute
  AdminSettingsChangelogPrivacyRoute: typeof AdminSettingsChangelogPrivacyRoute
}

const AdminSettingsChangelogRouteChildren: AdminSettingsChangelogRouteChildren =
  {
    AdminSettingsChangelogLabelsRoute: AdminSettingsChangelogLabelsRoute,
    AdminSettingsChangelogPrivacyRoute: AdminSettingsChangelogPrivacyRoute,
  }

const AdminSettingsChangelogRouteWithChildren =
  AdminSettingsChangelogRoute._addFileChildren(
    AdminSettingsChangelogRouteChildren,
  )

interface AdminSettingsCompanyRouteChildren {
  AdminSettingsCompanyBrandingRoute: typeof AdminSettingsCompanyBrandingRoute
  AdminSettingsCompanyDeleteRoute: typeof AdminSettingsCompanyDeleteRoute
  AdminSettingsCompanyPreferencesRoute: typeof AdminSettingsCompanyPreferencesRoute
}

const AdminSettingsCompanyRouteChildren: AdminSettingsCompanyRouteChildren = {
  AdminSettingsCompanyBrandingRoute: AdminSettingsCompanyBrandingRoute,
  AdminSettingsCompanyDeleteRoute: AdminSettingsCompanyDeleteRoute,
  AdminSettingsCompanyPreferencesRoute: AdminSettingsCompanyPreferencesRoute,
}

const AdminSettingsCompanyRouteWithChildren =
  AdminSettingsCompanyRoute._addFileChildren(AdminSettingsCompanyRouteChildren)

interface AdminSettingsPreferencesRouteChildren {
  AdminSettingsPreferencesEmailRoute: typeof AdminSettingsPreferencesEmailRoute
  AdminSettingsPreferencesLanguageRoute: typeof AdminSettingsPreferencesLanguageRoute
}

const AdminSettingsPreferencesRouteChildren: AdminSettingsPreferencesRouteChildren =
  {
    AdminSettingsPreferencesEmailRoute: AdminSettingsPreferencesEmailRoute,
    AdminSettingsPreferencesLanguageRoute:
      AdminSettingsPreferencesLanguageRoute,
  }

const AdminSettingsPreferencesRouteWithChildren =
  AdminSettingsPreferencesRoute._addFileChildren(
    AdminSettingsPreferencesRouteChildren,
  )

interface AdminSettingsRoadmapRouteChildren {
  AdminSettingsRoadmapArchiveRoute: typeof AdminSettingsRoadmapArchiveRoute
  AdminSettingsRoadmapPublicRoute: typeof AdminSettingsRoadmapPublicRoute
  AdminSettingsRoadmapStatusesRoute: typeof AdminSettingsRoadmapStatusesRoute
}

const AdminSettingsRoadmapRouteChildren: AdminSettingsRoadmapRouteChildren = {
  AdminSettingsRoadmapArchiveRoute: AdminSettingsRoadmapArchiveRoute,
  AdminSettingsRoadmapPublicRoute: AdminSettingsRoadmapPublicRoute,
  AdminSettingsRoadmapStatusesRoute: AdminSettingsRoadmapStatusesRoute,
}

const AdminSettingsRoadmapRouteWithChildren =
  AdminSettingsRoadmapRoute._addFileChildren(AdminSettingsRoadmapRouteChildren)

interface AdminSettingsRouteChildren {
  AdminSettingsAdminsRoute: typeof AdminSettingsAdminsRouteWithChildren
  AdminSettingsBoardsRoute: typeof AdminSettingsBoardsRouteWithChildren
  AdminSettingsChangelogRoute: typeof AdminSettingsChangelogRouteWithChildren
  AdminSettingsCompanyRoute: typeof AdminSettingsCompanyRouteWithChildren
  AdminSettingsPreferencesRoute: typeof AdminSettingsPreferencesRouteWithChildren
  AdminSettingsProfileRoute: typeof AdminSettingsProfileRoute
  AdminSettingsRoadmapRoute: typeof AdminSettingsRoadmapRouteWithChildren
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
  AdminSettingsCustomDomainsIndexRoute: typeof AdminSettingsCustomDomainsIndexRoute
}

const AdminSettingsRouteChildren: AdminSettingsRouteChildren = {
  AdminSettingsAdminsRoute: AdminSettingsAdminsRouteWithChildren,
  AdminSettingsBoardsRoute: AdminSettingsBoardsRouteWithChildren,
  AdminSettingsChangelogRoute: AdminSettingsChangelogRouteWithChildren,
  AdminSettingsCompanyRoute: AdminSettingsCompanyRouteWithChildren,
  AdminSettingsPreferencesRoute: AdminSettingsPreferencesRouteWithChildren,
  AdminSettingsProfileRoute: AdminSettingsProfileRoute,
  AdminSettingsRoadmapRoute: AdminSettingsRoadmapRouteWithChildren,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminSettingsCustomDomainsIndexRoute: AdminSettingsCustomDomainsIndexRoute,
}

const AdminSettingsRouteWithChildren = AdminSettingsRoute._addFileChildren(
  AdminSettingsRouteChildren,
)

interface AdminUsersRouteChildren {
  AdminUsersUserSlugRoute: typeof AdminUsersUserSlugRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersUserSlugRoute: AdminUsersUserSlugRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminChangelogChangelogSlugEditRouteChildren {
  AdminChangelogChangelogSlugEditDeleteRoute: typeof AdminChangelogChangelogSlugEditDeleteRoute
  AdminChangelogChangelogSlugEditPublishRoute: typeof AdminChangelogChangelogSlugEditPublishRoute
}

const AdminChangelogChangelogSlugEditRouteChildren: AdminChangelogChangelogSlugEditRouteChildren =
  {
    AdminChangelogChangelogSlugEditDeleteRoute:
      AdminChangelogChangelogSlugEditDeleteRoute,
    AdminChangelogChangelogSlugEditPublishRoute:
      AdminChangelogChangelogSlugEditPublishRoute,
  }

const AdminChangelogChangelogSlugEditRouteWithChildren =
  AdminChangelogChangelogSlugEditRoute._addFileChildren(
    AdminChangelogChangelogSlugEditRouteChildren,
  )

interface AdminRouteChildren {
  AdminFeedbackRoute: typeof AdminFeedbackRouteWithChildren
  AdminRoadmapRoute: typeof AdminRoadmapRouteWithChildren
  AdminSettingsRoute: typeof AdminSettingsRouteWithChildren
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminChangelogCreateRoute: typeof AdminChangelogCreateRoute
  AdminChangelogIndexRoute: typeof AdminChangelogIndexRoute
  AdminChangelogChangelogSlugEditRoute: typeof AdminChangelogChangelogSlugEditRouteWithChildren
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminFeedbackRoute: AdminFeedbackRouteWithChildren,
  AdminRoadmapRoute: AdminRoadmapRouteWithChildren,
  AdminSettingsRoute: AdminSettingsRouteWithChildren,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminChangelogCreateRoute: AdminChangelogCreateRoute,
  AdminChangelogIndexRoute: AdminChangelogIndexRoute,
  AdminChangelogChangelogSlugEditRoute:
    AdminChangelogChangelogSlugEditRouteWithChildren,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PublicRoute: PublicRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  PasswordResetTokenRoute: PasswordResetTokenRoute,
  PasswordResetIndexRoute: PasswordResetIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
